import BaseModelFactory from './base.factory'
import MilestoneService from './../services/Milestone.service'
import Milestone from './../models/milestone.model'

class MilestoneFactory extends BaseModelFactory {
  static search = async ({ search, pagination, order_by, method }) =>
    await this._search({ search, pagination, order_by, method }, { Service: MilestoneService, Model: Milestone })
  static findById = async id => await this._findBy({ id: id }, { Service: MilestoneService, Model: Milestone })
  static findAllById = async id => await this._findAllBy({ id: id }, { Service: MilestoneService, Model: Milestone })
  static create = payload => this._create(payload, { Service: MilestoneService, Model: Milestone })
}

export default MilestoneFactory
